import React, { useState, useEffect } from 'react';
import {
  Box,
  Text,
  Spacer,
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  Notify
} from '@flexisaf/flexibull2';
import Theme from 'utils/theme';
import PropTypes from 'prop-types';
import LocationPosting from './LocationPosting';

import urls from 'utils/config';
import request from 'utils/request';
import { TOP_RIGHT, ERROR, SUCCESS } from 'utils/constants';

const { API_BASE_URL } = urls || {};

const PostApplicantModal = ({
  open,
  handleModal,
  applicant,
  closeModals,
  setRefetchCandidates,
  updateApplicant
}) => {

  const [location, setLocation] = useState(null);
  const [posting, setPosting] = useState(false);

  useEffect(() => {
    if (applicant?.location?.id) {
      setLocation({
        label: `${applicant?.location?.name}`,
        value: applicant?.location.id,
      });
    }
  }, [applicant]);

  async function changeLocation() {
    setPosting(true);
    const url = `${API_BASE_URL}/candidates/${applicant?.id}`;
    const response = await request({
      method: 'patch',
      data: {
        locationId: location?.value,
      },
      url,
    });
    if (response.success) {
      updateApplicant(response.raw)
      Notify('Applicant location updated successfully', {
        position: TOP_RIGHT,
        status: SUCCESS,
      });
      closeModals();
      setRefetchCandidates(true);
      setPosting(true);
    } else {
      Notify(response.messsage, {
        position: TOP_RIGHT,
        status: ERROR,
      });
      setPosting(false);
    }
  }

  return (
    <Modal open={open}>
      <ModalBody width="600px">
        <Box pad="30px 30px 0" display="flex">
          <Text block>
            <Text block size="25px">
              {applicant?.location?.id
                ? 'Change applicant posting'
                : 'Post Applicant'}
            </Text>
            <Spacer space="4px" />
            <Text block size="10px">
              Select the Location you want this applicant to be posted to.
            </Text>
          </Text>
        </Box>
        <Box pad="15px 40px 40px">
          <Box background="#ccc" height="1px" />
          <Spacer space="40px" />
          <LocationPosting location={location} handleChange={setLocation} />
        </Box>
        <ModalFooter>
          <Box
            width="100%"
            display="flex"
            pad="25px 40px"
            style={{ justifyContent: 'space-between' }}
          >
            <Button
              onClick={() => handleModal(false)}
              color="transparent"
              pale
              fontColor={Theme.PrimaryRed}
            >
              Cancel
            </Button>
            <Button
              bold
              spaceLeft="15px"
              disabled={
                applicant?.location?.id === location?.value || !location
              }
              onClick={() => changeLocation()}
              progress={posting}
            >
              Post Applicant
            </Button>
          </Box>
        </ModalFooter>
      </ModalBody>
    </Modal>
  );
};

export default PostApplicantModal;

PostApplicantModal.propTypes = {
  open: PropTypes.bool,
  handleModal: PropTypes.func,
  applicant: PropTypes.object,
  closeModals: PropTypes.func,
  setRefetchCandidates: PropTypes.bool,
  updateApplicant: PropTypes.func
};
